import { PROJECT_STATUS_MAP } from 'modules/work-implementation/constants';
import { EMPTY_TABLE_MESSAGES } from '../constants';

/**
 * Returns the resolved initial view for the projects.
 *
 * @param {Object} projectsByStatus
 * @param {Array} views
 * @returns {string}
 */
export function getResolvedInitialView(projectsByStatus, views) {
  for (const view of views) {
    if (projectsByStatus[view]?.length > 0) {
      return view;
    }
  }
  return views[0];
}

/**
 * Returns the visible projects for the given view.
 *
 * @param {Object} projectsByStatus
 * @param {string} view
 * @returns {Array}
 */
export function getVisibleProjects(projectsByStatus, view) {
  if (!projectsByStatus) return [];
  return projectsByStatus[view] || [];
}

/**
 * Returns the empty message for the given view.
 *
 * @param {string} view
 * @returns {string}
 */
export const getEmptyMessage = (view) => {
  return EMPTY_TABLE_MESSAGES[view] || 'No jobs currently available';
};

export const getDisplayProjectStatus = (status) => {
  return PROJECT_STATUS_MAP[status] || status;
};
